import { TranslateFn } from '../../../hooks/context/useTranslate';
import { FilterError } from '../../../types/types';
import { MAX_CUSTOM_DELIMITER_LENGTH } from '../constants';
import { ExportEncoding, ExportFormat } from '../types';
import isDelimiterSupported from './isDelimiterSupported';
import isForbiddenDelimiter from './isForbiddenDelimiter';

// Emptiness is reported only once the user has tried to save, so clearing the field to retype stays quiet.
const resolveCustomDelimiterError = (
  customDelimiter: string,
  encoding: ExportEncoding,
  format: ExportFormat,
  isEmptyRejected: boolean,
  t: TranslateFn
): FilterError => {
  if (!customDelimiter) {
    return isEmptyRejected ? [t('export.customDelimiterEmpty')] : null;
  }

  // A forbidden character is unusable at any length, so it outranks the length rule.
  if (isForbiddenDelimiter(customDelimiter, format)) {
    return [t('export.customDelimiterForbidden')];
  }

  // Length is reported first: for input failing both rules it is the more actionable problem.
  if (Array.from(customDelimiter).length > MAX_CUSTOM_DELIMITER_LENGTH) {
    return [t('export.customDelimiterMaxLength')];
  }

  if (!isDelimiterSupported(customDelimiter, encoding)) {
    return [t('export.customDelimiterUnsupported')];
  }

  return null;
};

export default resolveCustomDelimiterError;
